import axios from "axios";
import {
  CreateReviewRequest,
  CreateReviewResponse,
  GetReviewsRequestParameters,
  GetReviewsResponse,
  ReviewRecommendResponse,
  ReviewResponse,
  SettlementReviewRequest,
  SettlementReviewResponse,
  UpdateReviewRequest,
  UpdateReviewResponse,
  UpdateReviewStatusRequest,
  UpdateReviewStatusResponse,
  CommissionRequestDto,
  CommissionResponseDto
} from "./dto/Review";

const createQuery = (params: GetReviewsRequestParameters): string => {
  const query: Record<string, string | boolean | null> = {
    ...params,
    sort: params.sort?.toString() ?? null,
    page: params.page?.toString() ?? null,
    amount: params.amount?.toString() ?? null,
    statuses: params.statuses?.join(",") ?? null,
    languages: params.languages?.join(",") ?? null,
    viewPermissions:params.viewPermissions?.join(",") ?? null,
  };
  const res = new URLSearchParams();
  for (const [key, value] of Object.entries(query)) {
    if (value) {
      res.set(key, value.toString());
    }
  }
  return res.toString();
};

// レビュー一覧取得
export const getReviews = async (
  parameters: GetReviewsRequestParameters
): Promise<GetReviewsResponse> => {
  const query = createQuery(parameters);
  const url = `/api/review/list?${query}`;
  const res = await axios.get<GetReviewsResponse>(url, {
    headers: { "Content-Type": "application/json;charset=utf-8" },
  });
  return res.data;
};

// レビュー一覧取得(おすすめ_関連)
// レビュー一覧取得(おすすめ_未ログイン)
export const getRecommendReviews = async (
  language?: string
): Promise<ReviewRecommendResponse[]> => {
  if (!language) {
    const res = await axios.get(`/api/review/recommend`, {
      headers: { "Content-Type": "application/json;charset=utf-8" },
    });
    return res.data;
  } else {
    const res = await axios.get(`/api/review/recommend?language=${language}`, {
      headers: { "Content-Type": "application/json;charset=utf-8" },
    });
    return res.data;
  }
};

// レビュー一覧取得(おすすめ_ログイン)
export const getRecommendLoggedInReviews = async (): Promise<
  ReviewRecommendResponse[]
> => {
  const res = await axios.get(`/api/review/recommend/loggedIn`, {
    headers: { "Content-Type": "application/json;charset=utf-8" },
  });
  return res.data;
};

// レビュー詳細取得
export const getReview = async (dealId: string): Promise<ReviewResponse> => {
  const res = await axios.get<ReviewResponse>(`/api/review?id=${dealId}`, {
    headers: { "Content-Type": "application/json;charset=utf-8" },
  });
  return res.data;
};

// レビュー削除
export const deleteReview = (dealId: string): Promise<void> => {
  return axios.delete(`/api/review?id=${dealId}`);
};

/**
 * レビュー作成
 * @param req リクエスト
 * @returns
 */
export const createReview = async (
  req: CreateReviewRequest
): Promise<CreateReviewResponse> => {
  const res = await axios.post<CreateReviewResponse>("/api/review", req, {
    headers: { "Content-Type": "application/json" },
  });
  return res.data;
};

/**
 * レビュー決済
 * @param dealId レビューID
 * @param req リクエスト
 * @returns
 */
export const settlementReview = async (
  dealId: string,
  req: SettlementReviewRequest
): Promise<SettlementReviewResponse> => {
  const res = await axios.post<SettlementReviewResponse>(
    `/api/settlement?id=${dealId}`,
    req,
    {
      headers: { "Content-Type": "application/json" },
    }
  );
  return res.data;
};

/**
 * レビュー更新
 * @param dealId レビューID
 * @param req リクエスト
 * @returns
 */
export const updateReview = async (
  dealId: string,
  req: UpdateReviewRequest
): Promise<UpdateReviewResponse> => {
  const res = await axios.put<UpdateReviewResponse>(
    `/api/review?id=${dealId}`,
    req,
    {
      headers: { "Content-Type": "application/json" },
    }
  );
  return res.data;
};

/**
 *
 * レビューステータス更新
 * @param dealId レビューID
 * @param req リクエスト
 * @returns
 */
export const updateReviewStatus = async (
  dealId: string,
  req: UpdateReviewStatusRequest
): Promise<UpdateReviewStatusResponse> => {
  const res = await axios.put<UpdateReviewStatusResponse>(
    `/api/review/status?id=${dealId}`,
    req,
    {
      headers: { "Content-Type": "application/json" },
    }
  );
  return res.data;
};

/**
 * レビュー金額取得
 * @param req リクエスト
 * @returns
 */
export const getCommission = async (
  req: CommissionRequestDto
): Promise<CommissionResponseDto> => {
  const res = await axios.post<CommissionResponseDto>("/api/review/commission", req, {
    headers: { "Content-Type": "application/json" },
  });
  return res.data;
};

// レビュー制限時間到達チェック
export const checkReviewTimeLimit = async (): Promise<void> => {
  await axios.post<void>("/api/users/deal/limit", {
    headers: { "Content-Type": "application/json;charset=utf-8" },
  });
};

// 3Dセキュア認証不正結果チェック
export const checkTdsNotExecuted = async (): Promise<void> => {
  await axios.post<void>("/api/users/deal/tds/check", {
    headers: { "Content-Type": "application/json;charset=utf-8" },
  });
};